import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { DataMap } from '@grapecity/wijmo.grid'

import { BaseComponent, DamagedUtility, FeatureType, Grid, ListItem, ModalSize, User, VpJob } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { DamagedUtilityComponent } from './damaged-utility.component'

@Component({
    selector: 'app-damaged-utilities',
    templateUrl: './damaged-utilities.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        GridExportComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class DamagedUtilitiesComponent extends BaseComponent {
    public grid: Grid<DamagedUtility>

    // Grid display maps (all jobs / all users so inactive/closed still render).
    jobMap = new DataMap([], 'value', 'display')
    userMap = new DataMap([], 'id', 'displayName')

    // Modal pick lists (active only).
    activeJobList: ListItem<string>[] = []
    activeUserList: ListItem<string>[] = []

    get currentUserId(): string {
        return this.services.authentication.userId()
    }

    get canEdit(): boolean {
        return this.services.authentication.hasFeature([FeatureType.FieldToolsDamagedUtilityLogEdit])
    }

    constructor() {
        super()
        this.grid = new Grid<DamagedUtility>(this.services)
            .setupModalEditing(
                this.services.data.damagedUtilities,
                'Damaged Utility',
                DamagedUtilityComponent,
                () => new DamagedUtility(),
                { component: this },
                ModalSize.large,
            )
            .wrapColumnHeaders()
            .filterBy(item => [
                item.job,
                String(this.jobMap.getDisplayValue(item.job) ?? ''),
                item.typeOfUtility,
                item.utilityOwner,
                item.blueStakeNumber,
                item.descriptionOfDamage,
                String(this.userMap.getDisplayValue(item.damagedByUserId) ?? ''),
            ])
        this.refresh()
    }

    public refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.vpJobs.queryAllByAction('GetAllJobs'),
                    this.services.data.users.queryAllByAction('GetForLookup'),
                    this.services.data.damagedUtilities.queryAll(),
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()

                        const allJobs = result[0] as VpJob[]
                        const allUsers = result[1] as User[]

                        const jobListItems = allJobs.map(j => new ListItem(j.id, j.id.trim() + ' ' + j.name))
                        this.jobMap = new DataMap(jobListItems, 'value', 'display')
                        this.userMap = new DataMap(allUsers, 'id', 'displayName')

                        this.activeJobList = allJobs
                            .filter(j => j.jobStatus === 1)
                            .sort((a, b) => a.id.trim().localeCompare(b.id.trim(), undefined, { numeric: true }))
                            .map(j => new ListItem(j.id, j.id.trim() + ' ' + j.name))
                        this.activeUserList = allUsers.filter(u => u.active).map(u => new ListItem(u.id, u.displayName))

                        this.grid.items = result[2] as DamagedUtility[]
                    },
                }),
        )
    }
}
